module.exports = __webpack_public_path__ + "static/media/avenir-medium.437daf5c.woff";